import createAnonymousOrder from './createAnonymousOrder';
import createOrderAndShareLink from './createOrderAndShareLink';
import createShareLinkByOrderReference from './createShareLinkByOrderReference';
import getOrderByOrderReferenceAndOrderPrice from './getOrderByOrderReferenceAndOrderPrice';
import getOwnerSummaryQuery from './getOwnerSummaryQuery';
import setCreateOrderGenericProduct from './setCreateOrderGenericProduct';

export const OwnerService = {
  createShareLinkByOrderReference,
  createOrderAndShareLink,
  getOrderByOrderReferenceAndOrderPrice,
  createAnonymousOrder,
  setCreateOrderGenericProduct,
  getOwnerSummaryQuery,
};
